var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-touch',{on:{"panup":_vm.panUp}},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"img"}),_vm._v(" "),_c('p',{staticClass:"text"},[_c('span',{staticClass:"icon"},[_vm._v("1")]),_vm._v("打开app\n      store，点击底部app按钮，滚动至页面底部，找到并选择“绑定支付宝、微信支付或银联卡”；\n    ")]),_vm._v(" "),_c('p',{staticClass:"up_icon"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99be4348","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsm_month_card/pay/one.vue
// module id = null
// module chunks = 